module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073fa_banner_800x600.50610794.png";